import React from 'react';

import { BadgeList } from '@wix/members-badge-lib';

import { Picture } from './picture';
import { Details } from './details';
import { ActionButton } from '../action-button';
import { FFBoxProps } from '../../containers/ff-box';
import { POSITION } from '../../constants/positioning';
import { FollowingFollowers } from './following-followers';
import MemberMoreButton from '../member-more-button';
import styles from './ff-box-desktop.scss';

export class FFBoxDesktop extends React.Component<FFBoxProps> {
  render() {
    const {
      member,
      pictureStyle,
      rolesActions,
      showAsBlocked,
      isBlocked,
      showFollowers,
      badgesSettings,
      currentMemberUid,
      goToFFPage,
      onRoleAction,
      goToMemberPage,
      followOrUnfollow,
      isRtlLocale,
    } = this.props;

    const memberNameId = `member-${member.uid}`;

    return (
      <>
        <div data-hook="ffBox" className={styles.container}>
          <div className={styles.selfAlignTop}>
            <Picture member={member} pictureStyle={pictureStyle || 0} goToMemberPage={goToMemberPage} />
          </div>
          <div className={styles.detailsBox}>
            <Details memberNameId={memberNameId} member={member} showAsBlocked={showAsBlocked} goToMemberPage={goToMemberPage} />
            {badgesSettings.badges.length > 0 && (
              <div className={styles.badgesContainer}>
                <BadgeList
                  {...badgesSettings}
                  align="left"
                  maxRows={1}
                  onClickMore={() => goToMemberPage(member.uid)}
                  onBadgeClick={() => goToMemberPage(member.uid)}
                />
              </div>
            )}

            {showFollowers && (
              <FollowingFollowers
                member={member}
                goToFFPage={goToFFPage}
                className={styles.followingFollowersContainer}
              />
            )}
          </div>

          {!isBlocked && (
            <ActionButton
              member={member}
              linkClassName={styles.actionBtn}
              containerClassName={styles.actionBtnContainer}
              goToMemberPage={goToMemberPage}
              currentMemberUid={currentMemberUid}
              followOrUnfollow={followOrUnfollow}
            />
          )}
          <MemberMoreButton
            member={member}
            position={POSITION.BOTTOM}
            onRoleAction={onRoleAction}
            rolesActions={rolesActions || []}
            containerClass={styles.moreActionsBtn}
            iconContainerClass="ma-fill-primary-text"
            isRtlLocale={isRtlLocale}
          />
        </div>
        <div className="ma-ff-dividers" />
      </>
    );
  }
}
